"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogSection = void 0;
const client_1 = require("@apollo/client");
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const sentry_quick_capture_1 = require("@app/util/sentry/sentry-quick-capture");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const employee_card_context_1 = require("../../util/employee-card-context");
const useEmployeeCardFooterContent_1 = require("../../util/hooks/useEmployeeCardFooterContent");
const loadAuditLogsQuery = (0, client_1.gql) `
  query AuditLogs($workspaceId: ID!, $userId: ID!) {
    role(workspace: $workspaceId, user: $userId) {
      auditLogs {
        created
        tKey
      }
    }
  }
`;
const tableConfig = [
    {
        key: 'tKey',
        tlKey: 'WS_SETTINGS_AUDIT_LOG_ACTION_NAME',
        sortable: true,
        filterable: true,
        rowToHTML: ({ tKey }) => ((0, util_1.isDefined)(tKey) && (0, util_1.isNotNull)(tKey) ? (0, util_1.t)(tKey) : '-'),
        rowToStr: ({ tKey }) => ((0, util_1.isDefined)(tKey) && (0, util_1.isNotNull)(tKey) ? (0, util_1.t)(tKey) : null),
    },
    {
        key: 'created',
        tlKey: 'HAPPENED',
        sortable: true,
        filterable: true,
        rowToHTML: (row) => (0, moment_1.default)(row.created).format('dd D.M. HH:mm:ss'),
        rowToStr: (row) => (0, moment_1.default)(row.created).format('yyyy-MM-DD HH:mm:ss'),
    },
];
const LogSection = () => {
    const { workspace, employee } = (0, employee_card_context_1.useEmployeeCard)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const variables = {
        workspaceId: workspace?.id,
        userId: employee?.user?.id,
    };
    const { data, loading: loadingAuditLogs, refetch, } = (0, client_1.useQuery)(loadAuditLogsQuery, {
        variables,
        onError: (error) => {
            (0, sentry_quick_capture_1.sentryQuickCapture)(error, variables);
            react_hot_toast_1.default.custom(() => react_1.default.createElement(ui_1.Alert, { type: ui_1.Alert.TYPES.ERROR, text: (0, util_1.t)('ERROR_SCREEN_TITLE') }), {
                duration: 5000,
            });
        },
    });
    react_1.default.useEffect(() => {
        refetch();
    }, [refetch]);
    const tableData = data?.role?.auditLogs.map((auditLog) => ({
        ...auditLog,
        employee: {
            name: `${employee?.user?.firstName ?? ''} ${employee?.user?.lastName ?? ''}`,
        },
    }));
    const { displayContent } = (0, useEmployeeCardFooterContent_1.useEmployeeCardFooterContent)(react_1.default.createElement("div", { style: { display: 'flex' } },
        react_1.default.createElement(ui_1.Button, { onClick: () => {
                closeModal();
                // void dispatch(setModal(null))
            } }, (0, util_1.t)('CLOSE')),
        react_1.default.createElement(ui_1.Button, { onClick: () => { }, style: 'CONTAINED', disabled: true }, (0, util_1.t)('SAVE'))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: 'calc(100% - 55px)',
                alignItems: 'start',
                padding: '1rem 0 0 0',
                boxSizing: 'border-box',
            } },
            react_1.default.createElement(ui_1.Table, { type: ui_1.Table.TYPES.FILL, tableName: 'audit-log', size: ui_1.Table.SIZE.SLIM, rows: tableData, tableConfig: tableConfig, showSelection: false, exportHidden: true, pagination: false, isLoading: loadingAuditLogs })),
        displayContent()));
};
exports.LogSection = LogSection;
